import * as React from 'react';

import { Asset } from '../../types';

interface ICardImage extends Asset {}

import styles from './CardImage.scss';

const CardImage: React.FunctionComponent<ICardImage> = (props) => (
  <div className={styles.image}>
    <img src={props.url} />
  </div>
);

CardImage.displayName = 'CardImage';

export default CardImage;
